module.exports = __webpack_public_path__ + "assets/img/introduction_culture_img_1.41164a6d.png";